import React, { Fragment, useContext } from "react";

import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { useNavigate, useLocation } from "react-router-dom";

import routes from "./../routes";
import { AuthContext } from "./../context/authContext";

import logo from "./../assets/img/logo/logo.png";

const SECTION_PREFIXES = {
    "/gestionOP": ["/gestionOP", "/NewGestionOP", "/EditeGestionOP", "/missionOrder"],
    "/dataManagement": ["/dataManagement", "/responsableTable", "/newResponsable", "/floatTable", "/newFloat", "/documentTable", "/newDocument", "/chargeVariable"],
};

const menuItemStyles = {
    button: ({ active, level }) => ({
        paddingLeft: level === 0 ? 22 : 54,
        paddingRight: 20,
        height: level === 0 ? 46 : 38,
        color: active ? "#1cbcb4" : "rgba(255, 255, 255, 0.62)",
        backgroundColor: active ? "rgba(28, 188, 180, 0.12)" : "transparent",
        borderRight: active ? "3px solid #1cbcb4" : "3px solid transparent",
        fontWeight: active ? 600 : 500,
        fontSize: level === 0 ? "0.85rem" : "0.78rem",
        transition: "background-color .15s ease, color .15s ease",
        "&:hover": {
            backgroundColor: active ? "rgba(28, 188, 180, 0.16)" : "rgba(255, 255, 255, 0.05)",
            color: active ? "#1cbcb4" : "rgba(255, 255, 255, 0.92)",
        },
    }),
    icon: ({ active }) => ({
        color: active ? "#1cbcb4" : "rgba(255, 255, 255, 0.5)",
        minWidth: 20,
        fontSize: "1.05rem",
        marginRight: 12,
    }),
    subMenuContent: {
        backgroundColor: "rgba(0, 0, 0, 0.18)",
    },
    SubMenuExpandIcon: {
        color: "rgba(255, 255, 255, 0.35)",
    },
};

const logoutMenuItemStyles = {
    button: {
        paddingLeft: 22,
        paddingRight: 20,
        height: 44,
        color: "rgba(255, 255, 255, 0.62)",
        fontWeight: 500,
        fontSize: "0.85rem",
        transition: "background-color .15s ease, color .15s ease",
        "&:hover": {
            backgroundColor: "rgba(245, 54, 92, 0.14)",
            color: "#f5365c",
        },
    },
    icon: {
        color: "rgba(255, 255, 255, 0.5)",
        minWidth: 20,
        fontSize: "1.05rem",
        marginRight: 12,
    },
};

function SideBar() {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useContext(AuthContext);

    const email = sessionStorage.getItem("email");

    const relPath = location.pathname.startsWith("/admin")
        ? location.pathname.slice("/admin".length) || "/index"
        : location.pathname;

    const isSectionActive = (path) => {
        const prefixes = SECTION_PREFIXES[path] || [path];
        return prefixes.some((p) => relPath === p || relPath.startsWith(p + "/"));
    };

    const handleRedirection = (value) => {
        navigate(value);
    };

    const handleLogout = () => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("id");
        sessionStorage.removeItem("email");
        logout();
        navigate("/auth/login");
    };

    const mainRoutes = routes.filter(el => el.show && el.name !== "Déconnexion");
    const accountRoutes = routes.filter(el => el.show && el.name === "Déconnexion");

    const getRoutes = (routesToRender) => {
        return routesToRender.map((prop, key) => {
            if (prop.subMenu && prop.subMenu[0]) {
                const sectionActive = isSectionActive(prop.path);

                return (
                    <SubMenu
                        key={key}
                        icon={prop.icon}
                        label={prop.name}
                        active={sectionActive}
                        defaultOpen={sectionActive}
                    >
                        {prop.subMenu.filter(el => el.show).map((subItem, subKey) => (
                            <MenuItem
                                key={subKey}
                                icon={subItem.icon}
                                active={relPath === subItem.path}
                                onClick={() => handleRedirection(subItem.layout + subItem.path)}
                            >
                                {subItem.name}
                            </MenuItem>
                        ))}
                    </SubMenu>
                );
            }

            return (
                <MenuItem
                    key={key}
                    icon={prop.icon}
                    active={isSectionActive(prop.path)}
                    onClick={() => handleRedirection(prop.layout + prop.path)}
                >
                    {prop.name}
                </MenuItem>
            );
        });
    };

    return (
        <Fragment>
            <section className="sideBarExemple">
                <Sidebar backgroundColor="transparent" width="100%" rootStyles={{ border: "none", height: "100%" }}>
                    <div className="brandHeader">
                        <img src={logo} alt="Wilaya de la Région Sous Massa" />
                        <div className="brandText">
                            <span className="brandName">E-Wilaya</span>
                            <span className="brandSub">Agadir Idda Outanane</span>
                        </div>
                    </div>

                    <Menu menuItemStyles={menuItemStyles} rootStyles={{ flex: 1 }}>
                        {getRoutes(mainRoutes)}
                    </Menu>

                    <div className="sideBarFooter">
                        {email && (
                            <div className="sessionInfo">
                                <span className="sessionDot"></span>
                                <span className="sessionEmail">{email}</span>
                            </div>
                        )}

                        <Menu menuItemStyles={logoutMenuItemStyles}>
                            {accountRoutes.map((prop, key) => (
                                <MenuItem key={key} icon={prop.icon} onClick={handleLogout}>
                                    {prop.name}
                                </MenuItem>
                            ))}
                        </Menu>
                    </div>
                </Sidebar>
            </section>
        </Fragment>
    );
}

export default SideBar;
